// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"108":"93c52c45164970979c04","125":"63202e932386c84d5a4c","223":"68ec96e7f1fca374fe38","293":"159321e997650ab5845d","452":"0c2ff11b2ddbb349a03e"}[chunkId] + ".js";
};